import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Link, Route, HashRouter as Router, Routes } from 'react-router-dom';
import { routes } from './routes';

console.log(routes);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {routes.map(({ path, element }) => <Route key={path} path={path} element={element}/>)}
        <Route path="*" element={<div>Available routes: <ul>
          {routes.map(route => <li><Link to={route.path}>{route.path}</Link></li>)}</ul>
        </div>}/>
      </Routes>
    </Router>
  </React.StrictMode>,
);
